import { Component } from '@angular/core';
import { NotificationService } from '@progress/kendo-angular-notification';
import { BrowserService } from 'src/app/services/browser.service';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  standalone: false,
})
export class PagesComponent {
  public selectedDate: Date = new Date();
  readonly unsupportedBrowserMessage: string =
    'You’re on an unsupported browser, please use the latest version of either Edge or Chrome instead.';

  constructor(
    private browserService: BrowserService,
    private notificationService: NotificationService
  ) {
    if (!this.browserService.isEdge() && !this.browserService.isChrome()) {
      this.notificationService.show({
        content: this.unsupportedBrowserMessage,
        cssClass: 'notification-error pages-notification-font',
        position: { horizontal: 'center', vertical: 'top' },
        animation: { type: 'slide', duration: 60 },
        type: { style: 'warning', icon: true },
        closable: true,
      });
    }
  }
}
